/* eslint-disable prefer-arrow-callback */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-nested-ternary */
import { Card, Grid, Stack, Step, StepLabel, Stepper } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import DashboardLayout from "utils/LayoutContainers/DashboardLayout";
import DashboardNavbar from "utils/Navbars/DashboardNavbar";
import MDTypography from "components/MDTypography";
import Loader from "utils/Loader";
import {
  fetchKPIActivities,
  fetchBadges,
  fetchCampaigns,
  fetchCompetitionTypes,
  fetchWinConditions,
  addCompetition,
  fetchCompetition,
  updateCompetition,
} from "apis/compete";
import useUserPilot from "hooks/useUserPilot";
import { enqueueSnackbar } from "notistack";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { checkPermission } from "utils/HelperFunctions";
import { MODULES, COMPONENTS, PERMISSIONS_NAME } from "lib/constants";
import { checkUserModuleComponentEnabled } from "utils/Modules";
import CompetitionInfo from "./CompetitionFormSteps.js/CompetitionInfo";
import Criteria from "./CompetitionFormSteps.js/Criteria";
import Duration from "./CompetitionFormSteps.js/Duration";
import Participants from "./CompetitionFormSteps.js/Participants";
import "../../../../styles/compete.scss";
import validationSchema from "../Validations";

function getSteps() {
  return ["Competition Info", "Criteria", "Duration", "Participants"];
}

function getStepContent(
  stepIndex,
  formData,
  kpiActivities,
  badges,
  badgeLoading,
  types,
  typesLoading,
  winConditions,
  winConditionLoading,
  campaigns,
  campaignsLoading,
  previousCampaignId
) {
  switch (stepIndex) {
    case 0:
      return (
        <CompetitionInfo
          formData={formData}
          badges={badges}
          badgeLoading={badgeLoading}
          types={types}
          typesLoading={typesLoading}
          campaigns={campaigns}
          campaignsLoading={campaignsLoading}
          previousCampaignId={previousCampaignId}
        />
      );
    case 1:
      return (
        <Criteria
          formData={formData}
          kpiActivities={kpiActivities}
          winConditions={winConditions}
          winConditionLoading={winConditionLoading}
        />
      );
    case 2:
      return <Duration formData={formData} />;
    case 3:
      return <Participants formData={formData} />;
    default:
      return null;
  }
}

function CompetitionForm() {
  const user = useSelector((state) => state.loginUser.loginUserState);
  const modules = useSelector((state) => state.modules.enabledModules);
  const { id } = useParams();
  const Userpilot = useUserPilot();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [initialValues, setInitialValues] = useState({
    info: {
      name: "",
      type:
        (checkPermission(PERMISSIONS_NAME?.COMPETE_UNRANKED, user?.userPermission) &&
          checkPermission(PERMISSIONS_NAME?.COMPETE_TREMENDOUS_PAYOUT, user?.userPermission)) ||
        user.type !== "user"
          ? null
          : checkUserModuleComponentEnabled(
              modules,
              MODULES.COMPETITIONS,
              COMPONENTS.COMPETITIONS.REWARDS
            ) && checkPermission(PERMISSIONS_NAME?.COMPETE_TREMENDOUS_PAYOUT, user?.userPermission)
          ? "Tremendous Payout"
          : "Unranked",
      description: "",
      badge: "",
      reward: "",
      campaignId: "",
    },
    criteria: {
      winCondition: null,
      target: "",
      kpiActivities: [
        {
          id: null,
          name: "",
          count: 1,
          points: 1,
        },
      ],
    },
    duration: {
      startDate: "",
      endDate: "",
      timezone: user.timezone,
      repeatCompetition: false,
      repeatInterval: "",
      customRepeatInterval: null,
    },
    participants: {
      joinable: false,
      users: [],
    },
    addCompetitionAsFav: false,
  });
  const [kpiActivities, setKpiActivities] = useState([]);
  const [badges, setBadges] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [previousCampaignId, setPreviousCampaignId] = useState("");
  const [types, setTypes] = useState([]);
  const [winConditions, setWinConditions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [draftLoading, setDraftLoading] = useState(false);
  const [typesLoading, setTypesLoading] = useState(false);
  const [badgeLoading, setBadgeLoading] = useState(false);
  const [campaignsLoading, setCampaignsLoading] = useState(false);
  const [winConditionLoading, setWinConditionLoading] = useState(false);
  const [submitButtonClicked, setSubmitButtonClicked] = useState(false);

  const steps = getSteps();

  const currentValidation = validationSchema[activeStep];
  const isLastStep = activeStep === steps.length - 1;

  const handleBack = () => setActiveStep(activeStep - 1);

  const formatBEResponse = (data) => {
    const formattedData = {
      info: {},
      criteria: {
        kpiActivities: [],
      },
      participants: {
        users: [],
      },
    };

    formattedData.info = {
      name: pathname.includes("copy") ? `Copy of ${data?.name}` : data?.name,
      type: data?.type?.[0]?.toUpperCase() + data?.type?.slice(1) || null,
      status: data?.status,
      reward: data?.reward,
      description: data?.description,
      badge: data?.badge,
      campaignId: data?.campaignId,
    };

    formattedData.criteria.winCondition = data?.CompetitionWinCondition;
    formattedData.criteria.target = data?.target || "";

    formattedData.criteria.kpiActivities = data?.KpiTemplatesActivities?.map((activity) => ({
      id: activity?.kpiActionId,
      name: activity?.KpiActivity?.name,
      count: activity?.count || 1,
      points: activity?.points || 1,
    }));

    formattedData.duration = {
      startDate: pathname.includes("copy") ? "" : moment.tz(data?.startDatetime, data?.timezone),
      endDate: pathname.includes("copy") ? "" : moment.tz(data?.endDatetime, data?.timezone),
      timezone: data?.timezone,
      repeatCompetition: data?.repeatCompetition || false,
      repeatInterval: data?.repeatInterval,
      customRepeatInterval: {
        repeatEveryCount: data?.repeatEveryCount,
        repeatEveryType: data?.repeatEveryType,
        repeatOn: data?.repeatOn,
        repeatEnds: data?.repeatEnds,
        repeatEndsOn: data?.repeatEndsOn ? moment.tz(data?.repeatEndsOn, data?.timezone) : null,
        occurrences: data?.occurrences,
      },
    };

    formattedData.participants.users = data?.CompetitionMembers?.map((selectedUser) => ({
      id: selectedUser?.userId,
      name: selectedUser?.User?.name,
    }));

    formattedData.participants.joinable = data?.joinable;

    formattedData.addCompetitionAsFav = !!data?.CompetitionFavorite;

    return formattedData;
  };

  const getCompetition = async () => {
    try {
      setIsLoading(true);
      const response = await fetchCompetition(id);

      if (response?.data?.success) {
        const formattedCompetition = formatBEResponse(response.data.data);

        if (
          pathname.includes("edit") &&
          (response?.data?.data?.status === "running" || response?.data?.data?.status === "closed")
        ) {
          setIsLoading(false);
          enqueueSnackbar(
            JSON.stringify({
              icon: "error",
              title: "Error",
              text: "Only Open and Draft competitions can be edited.",
            }),
            {
              variant: "custom",
            }
          );
          navigate(-1);
          return;
        }

        if (
          pathname.includes("edit") &&
          moment
            .tz(response?.data?.data?.startDatetime, user.timezone)
            .subtract(15, "minutes")
            .isSameOrBefore(moment.tz(undefined, user.timezone)) &&
          response?.data?.data?.status === "open"
        ) {
          setIsLoading(false);
          enqueueSnackbar(
            JSON.stringify({
              icon: "error",
              title: "Error",
              text: "Competition can't be edited 15 minutes before its start time.",
            }),
            {
              variant: "custom",
            }
          );
          navigate(-1);
          return;
        }

        setInitialValues(formattedCompetition);
      } else if (response?.response?.status !== 403) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: response?.response?.data?.message || "Something Went Wrong",
          }),
          {
            variant: "custom",
          }
        );
        if (response?.response?.status === 404) {
          navigate(-1);
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: error.message || "Something Went Wrong",
        }),
        {
          variant: "custom",
        }
      );
    }
  };

  const formatPayload = (data, status) => {
    const payload = {
      assignmentList: [],
    };

    let selectedTremendousCampaignId =
      campaigns.find((campaign) => campaign.name === data?.info?.campaignId)?.id || null;

    if (selectedTremendousCampaignId === "no-campaign") {
      selectedTremendousCampaignId = null;
    }

    payload.kpiPayload = data.criteria.kpiActivities.map((activity) => ({
      id: activity.id,
      name: activity.name,
      count: data.criteria.winCondition.condition === "Total Points" ? activity.count : 0,
      points: data.criteria.winCondition.condition === "Total Points" ? activity.points : 0,
    }));
    payload.competitionPayload = {
      ...data?.info,
      campaignId: selectedTremendousCampaignId,
      type: data?.info?.type?.toLowerCase(),
      winConditionId: data?.criteria?.winCondition?.id,
      startDatetime: data?.duration?.startDate?.format("DD-MM-YYYY HH:mm"),
      endDatetime: data?.duration?.endDate && data?.duration?.endDate?.format("DD-MM-YYYY HH:mm"),
      timezone: data?.duration?.timezone,
      target:
        data?.criteria?.winCondition?.condition === "First To KPI Target"
          ? data?.criteria?.target
          : null,
      joinable: data?.participants.joinable,
      addCompetitionAsFav: data?.addCompetitionAsFav,
      status,
      repeatCompetition: data?.duration?.repeatCompetition,
      repeatInterval: data?.duration?.repeatCompetition ? data?.duration?.repeatInterval : null,
      customRepeatInterval: data?.duration?.customRepeatInterval,
    };

    payload.assignmentList = data.participants.users.map((selectedUser) => ({
      id: selectedUser.id,
    }));

    return payload;
  };

  const handleCompetitionAdd = async (data, status) => {
    try {
      if (status === "open") {
        setSubmitLoading(true);
      } else {
        setDraftLoading(true);
      }
      const response = await addCompetition(formatPayload(data, status));
      if (response?.data?.success) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "success",
            title: "Success",
            text: response?.data?.message || "Template Added Successfully",
          }),
          {
            variant: "custom",
          }
        );
        Userpilot.track("Competition Created", { competitionName: data.name });
        navigate("/compete/builder");
      }
      //  else if (response?.response?.status === 422) {
      //   setActiveStep(0);
      //   actions.setErrors({
      //     info: {
      //       name: "Template name already exists",
      //     },
      //   });
      // }
      else if (response?.response?.status !== 403) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: response?.response?.data?.message || "Something Went Wrong",
          }),
          {
            variant: "custom",
          }
        );
      }
      setSubmitLoading(false);
      setDraftLoading(false);
    } catch (error) {
      setSubmitLoading(false);
      setDraftLoading(false);
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: error.message || "Something Went Wrong",
        }),
        {
          variant: "custom",
        }
      );
    }
  };
  const handleCompetitionEdit = async (data, status) => {
    try {
      if (status === "open") {
        setSubmitLoading(true);
      } else {
        setDraftLoading(true);
      }

      const payload = formatPayload(data, status);

      payload.removeUserAssignIds = initialValues.participants.users
        .filter(
          (initialUser) =>
            !payload.assignmentList.some((selectedUser) => initialUser.id === selectedUser.id)
        )
        .map((removedUser) => removedUser.id);

      payload.assignmentList = payload.assignmentList.filter(
        (selectedUser) =>
          !initialValues.participants.users.some(
            (newSelectedUser) => newSelectedUser.id === selectedUser.id
          )
      );

      const response = await updateCompetition(id, payload);
      if (response?.data?.success) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "success",
            title: "Success",
            text: response?.data?.message || "Template Added Successfully",
          }),
          {
            variant: "custom",
          }
        );
        navigate("/compete/builder");
      }
      //  else if (response?.response?.status === 422) {
      //   setActiveStep(0);
      //   actions.setErrors({
      //     info: {
      //       name: "Template name already exists",
      //     },
      //   });
      // }
      else if (response?.response?.status !== 403) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: response?.response?.data?.message || "Something Went Wrong",
          }),
          {
            variant: "custom",
          }
        );
      }
      setSubmitLoading(false);
      setDraftLoading(false);
    } catch (error) {
      setSubmitLoading(false);
      setDraftLoading(false);
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: error.message || "Something Went Wrong",
        }),
        {
          variant: "custom",
        }
      );
    }
  };

  const handleFormSubmit = async (data, actions, status) => {
    if (isLastStep) {
      if (!id || (id && pathname.includes("copy"))) {
        handleCompetitionAdd(data, status);
      } else {
        handleCompetitionEdit(data, status);
      }
    } else {
      setActiveStep(activeStep + 1);
      actions.setTouched({});
    }
  };

  const getKpiActivities = async () => {
    try {
      const response = await fetchKPIActivities();
      if (response?.data?.success) {
        setKpiActivities(response?.data?.data);
      } else if (response?.response?.status !== 403) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: response?.response?.data?.message || "Something Went Wrong",
          }),
          {
            variant: "custom",
          }
        );
      }
    } catch (error) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: error.message || "Something Went Wrong",
        }),
        {
          variant: "custom",
        }
      );
    }
  };

  const getBadges = async () => {
    try {
      setBadgeLoading(true);
      const response = await fetchBadges();
      if (response?.data?.success) {
        setBadges(response.data.data);
        // setBadges([]);
      } else if (response?.response?.status !== 403) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: response?.response?.data?.message || "Something Went Wrong",
          }),
          {
            variant: "custom",
          }
        );
      }
      setBadgeLoading(false);
    } catch (error) {
      setBadgeLoading(false);
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: error.message || "Something Went Wrong",
        }),
        {
          variant: "custom",
        }
      );
    }
  };

  const getCampaigns = async () => {
    try {
      setCampaignsLoading(true);
      const response = await fetchCampaigns();
      if (response?.data?.success) {
        const campaignsFromApi = response?.data?.campaigns || [];
        setCampaigns([{ id: "no-campaign", name: "None" }, ...campaignsFromApi]);
        setPreviousCampaignId(response.data.previousCampaignId);
      } else if (response?.response?.status !== 403) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: response?.response?.data?.message || "Something Went Wrong",
          }),
          {
            variant: "custom",
          }
        );
      }
      setCampaignsLoading(false);
    } catch (error) {
      setCampaignsLoading(false);
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: error.message || "Something Went Wrong",
        }),
        {
          variant: "custom",
        }
      );
    }
  };

  const getTypes = async () => {
    try {
      setTypesLoading(true);
      const response = await fetchCompetitionTypes();
      if (response?.data?.success) {
        setTypes(response.data.data.map(({ type }) => type?.[0]?.toUpperCase() + type?.slice(1)));
        // setBadges([]);
      } else if (response?.response?.status !== 403) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: response?.response?.data?.message || "Something Went Wrong",
          }),
          {
            variant: "custom",
          }
        );
      }
      setTypesLoading(false);
    } catch (error) {
      setTypesLoading(false);
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: error.message || "Something Went Wrong",
        }),
        {
          variant: "custom",
        }
      );
    }
  };

  const getWinConditions = async () => {
    try {
      setWinConditionLoading(true);
      const response = await fetchWinConditions();
      if (response?.data?.success) {
        setWinConditions(response.data.data);
      } else if (response?.response?.status !== 403) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: response?.response?.data?.message || "Something Went Wrong",
          }),
          {
            variant: "custom",
          }
        );
      }
      setWinConditionLoading(false);
    } catch (error) {
      setWinConditionLoading(false);
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: error.message || "Something Went Wrong",
        }),
        {
          variant: "custom",
        }
      );
    }
  };

  useEffect(() => {
    getKpiActivities();
    getBadges();
    getTypes();
    getWinConditions();
    getCampaigns();
  }, []);

  useEffect(
    () => () => {
      moment.tz.setDefault(moment.tz.guess());
    },
    []
  );

  useEffect(() => {
    if (id) {
      getCompetition();
    }
  }, [id]);

  return (
    <DashboardLayout>
      {/* header */}
      <DashboardNavbar />
      <MDBox py={3} className="competition-form-wrapper">
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={12} lg={10}>
            <MDTypography variant="h4">
              {id ? (pathname.includes("copy") ? "Copy" : "Edit") : "Add"} Competition
            </MDTypography>
          </Grid>
        </Grid>
        <Grid container justifyContent="center" alignItems="center" sx={{ height: "100%", mt: 8 }}>
          <Grid item xs={12} lg={10}>
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={currentValidation}
              onSubmit={(values, actions) => {
                handleFormSubmit(values, actions, submitButtonClicked ? "open" : "draft");
              }}
              // eslint-disable-next-line consistent-return
              validate={(values) => {
                const errors = {
                  duration: {},
                };

                if (activeStep === steps.length - 1) {
                  if (
                    moment
                      .tz(values.duration.startDate, values.duration.timezone)
                      .isBefore(moment.tz(undefined, values.duration.timezone).add(15, "minutes"))
                  ) {
                    errors.duration.startDate =
                      "Start Time must be 15 minutes greater than selected timezone's current time";
                    setActiveStep(2);
                  }
                }
                if (Object.keys(errors.duration).length === 0) {
                  delete errors.duration;
                }
                return errors;
              }}
            >
              {({ values, errors, touched, setFieldValue }) => (
                <Form autoComplete="off">
                  <Card sx={{ height: "100%" }}>
                    <MDBox mx={4} mt={-3}>
                      <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => (
                          <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                    </MDBox>
                    <MDBox sx={{ position: "relative" }} p={3}>
                      <Loader loading={isLoading} />

                      <MDBox>
                        {getStepContent(
                          activeStep,
                          {
                            values,
                            touched,
                            errors,
                            setFieldValue,
                          },
                          kpiActivities,
                          badges,
                          badgeLoading,
                          types,
                          typesLoading,
                          winConditions,
                          winConditionLoading,
                          campaigns,
                          campaignsLoading,
                          previousCampaignId
                        )}
                        <MDBox
                          mt={isLastStep ? 2 : 4}
                          width="100%"
                          px={1}
                          display="flex"
                          justifyContent="space-between"
                        >
                          {activeStep === 0 ? (
                            <MDBox />
                          ) : (
                            <MDButton
                              variant="gradient"
                              color="secondary"
                              onClick={handleBack}
                              sx={{ px: "0.75rem" }}
                            >
                              PREV
                            </MDButton>
                          )}
                          <Stack direction="row" spacing={1}>
                            {isLastStep &&
                              (!id ||
                                values.info.status !== "open" ||
                                pathname.includes("copy")) && (
                                <MDButton
                                  sx={{ px: "0.65rem" }}
                                  type="submit"
                                  onClick={() => {
                                    setSubmitButtonClicked(false);
                                  }}
                                  disabled={submitLoading || draftLoading}
                                  variant="outlined"
                                  color="newColor"
                                >
                                  {draftLoading ? "Loading" : "SAVE AS DRAFT"}
                                </MDButton>
                              )}
                            <MDButton
                              sx={{ px: "0.75rem" }}
                              type="submit"
                              onClick={() => {
                                setSubmitButtonClicked(true);
                              }}
                              disabled={submitLoading || draftLoading}
                              color={isLastStep ? "secondaryGreen" : "gray80"}
                            >
                              {isLastStep ? (submitLoading ? "Loading" : "COMPLETE") : "NEXT"}
                            </MDButton>
                          </Stack>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default CompetitionForm;
